import styled from 'styled-components';
import loadable from '@loadable/component';
export const ReactMarkdown = loadable(() => import('react-markdown'));
export const StyledMarkdown = styled(ReactMarkdown) `
  ol,
  ul {
    text-align: left;
  }
  ${({ textSize }) => textSize && (textSize == 'Large' ? 'font-size: 1.5rem' : 'font-size: 1rem')}
`;
//# sourceMappingURL=StyledMarkdown.js.map